import { render, staticRenderFns } from "./routerLab.vue?vue&type=template&id=07c5e842&scoped=true"
import script from "./routerLab.vue?vue&type=script&lang=js"
export * from "./routerLab.vue?vue&type=script&lang=js"
import style0 from "./routerLab.vue?vue&type=style&index=0&id=07c5e842&prod&lang=scss"
import style1 from "./routerLab.vue?vue&type=style&index=1&id=07c5e842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5e842",
  null
  
)

export default component.exports